import {
    Avatar,
    Badge,
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Grid,
    IconButton,
    InputAdornment,
    Paper,
    Tab,
    Tabs,
    TextField,
} from "@material-ui/core";
import { Close, CloseOutlined, SearchOutlined } from "@material-ui/icons";
import CancelOutlinedIcon from "@material-ui/icons/CancelOutlined";
import CheckCircleOutlinedIcon from "@material-ui/icons/CheckCircleOutlined";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import _ from "underscore";
import NotFound from "../../../assets/images/NotFound.svg";
import ThumbLine from "../../../assets/images/updateImage.svg";
import { IsNullOrEmpty } from "../../../helpers/utility";
import { uploadProductsRequest } from "../../../store/file/file.actions";
import { getUploadedProductImage } from "../../../store/file/file.selector";
import SocialAPI from "../../../store/social/social.api";
import {
    getImage,
    getSearchedUsers,
    getUserProfile,
} from "../../../store/user/user.selector";
import {
    createVIPCircleRequest,
    deleteVIPCircleRequest,
    updateVIPCircleRequest,
} from "../../../store/user/vipcircle/vipcircle.actions";

export default function ManageVIPCircle(props) {
    const dispatch = useDispatch();
    const [form, setForm] = useState(false);
    const [guests, setGuests] = useState([]);
    const [annuallySubscription, setAnnuallySubscription] = useState("");
    const [monthlySubscription, setMonthlySubscription] = useState("");
    const [searchText, setSearchText] = useState("");
    const [bannerImageSrc, setBannerImageSrc] = useState("");
    const [description, setDescription] = useState("");
    const [showShared, setShared] = useState(false);
    const [title, setTitle] = useState("");
    const [selectedMenu, setSelectedMenu] = useState("");
    const [vipGuests, setVIPGuests] = useState([]);
    const { userProfile, users, thumbnail } = useSelector((state) => {
        return {
            userProfile: getUserProfile(state),
            thumbnail: getUploadedProductImage(state),
            users: getSearchedUsers(state),
        };
    });

    const validate = () => {
        return (
            !IsNullOrEmpty(monthlySubscription) &&
            !IsNullOrEmpty(annuallySubscription) &&
            !IsNullOrEmpty(description) &&
            !IsNullOrEmpty(title)
        );
    };

    useEffect(() => {
        if (props.mode === "edit") {
            setAnnuallySubscription(props.VIPCircle.annuallySubscription);
            setMonthlySubscription(props.VIPCircle.monthlySubscription);
            setDescription(props.VIPCircle.description);
            setTitle(props.VIPCircle.title);
            setBannerImageSrc(getImage(props.VIPCircle.avatar));
            setVIPGuests(props.VIPCircle.guests);
        }
    }, [props]);

    const changeBanner = async (e) => {
        const files = e.target.files[0];

        dispatch(uploadProductsRequest(files));

        const reader = new FileReader();
        reader.addEventListener(
            "load",
            function () {
                setBannerImageSrc(reader.result);
            },
            false
        );

        if (files) {
            reader.readAsDataURL(files);
        } else {
            setBannerImageSrc("");
        }
    };

    const handleDelete = () => {
        Swal.fire({
            title: "Delete VIP Circle",
            text: "Are you sure want to delete this circle.?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "green",
            cancelButtonText: "Cancel",
            confirmButtonText: "Yes",
            customClass: {
                cancelButton: "order-1 right-gap",
                confirmButton: "order-2",
                denyButton: "order-3",
            },
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(deleteVIPCircleRequest(props.VIPCircle._id));
            }
        });
    };

    const handleSave = () => {
        if (validate()) {
            if (props.mode === "add") {
                let curGuests = users
                    .filter((x) => {
                        return guests.indexOf(x._id) > -1;
                    })
                    .map((y) => {
                        return {
                            userId: y._id,
                            name: y.fullName,
                            thumbnail: getImage(y.attachments),
                            status: "Invited",
                        };
                    });
                dispatch(
                    createVIPCircleRequest({
                        title: title,
                        description: description,
                        thumbnail: thumbnail,
                        monthlySubscription: monthlySubscription,
                        annuallySubscription: annuallySubscription,
                        guests: curGuests,
                    })
                );
            } else {
                let curGuests = users
                    .filter((x) => {
                        return guests.indexOf(x._id) > -1;
                    })
                    .map((y) => {
                        let mail = `<p style="text-align: center;
                    background: #8B22F9;
                    color: white;
                    font-weight: bold;
                    line-height: 28px;
                    font-size: 20px;
                    padding: 12px;">
                        Access Granted
                    </p>
                    <p style="line-height: 30px;text-align: center;">
                        <span style="color:#8B22F9">${
                            userProfile.fullName
                        }</span> is delighted to give you access to join their
                        VIP Room live sessions.
                        <br />
                        <br />
                        Join their room before it ends
                    </p>
                    <div style="border: 1px solid; border-radius: 30px;padding: 10px">
                        <table border="0">
                            <tr>
                                <td>
                                    <img width="100" height="100"
                                        src="${getImage(userProfile.avatar)}" />
                                </td>
                                <td>
                                    <p style="color: #8B22F9; font-weight:bold;line-height: 12px;">${
                                        userProfile.fullName
                                    }</p>
                                    <p style="color: #000; font-weight:bold;line-height: 12px">${title}</p>
            
                                    <p style="text-align: center;padding: 16px;">
                                        <a href="https://app.ulalive.com/" style="background: #8B22F9;
                        color: white;
                        padding: 16px;
                        text-decoration: none;
                        border-radius: 16px;
                        font-weight: bold;">
                                            Join Live
                                        </a>
                                    </p>
                                </td>
                            </tr>
                        </table>
                    </div>`;

                        SocialAPI.sendEmailNotification({
                            message: mail,
                            subject: "VIP Circle Access Granted From Ulalive",
                            to: y.email,
                        });

                        return {
                            userId: y._id,
                            name: y.fullName,
                            thumbnail: getImage(y.attachments),
                            status: "Approved",
                        };
                    });

                dispatch(
                    updateVIPCircleRequest({
                        _id: props.VIPCircle._id,
                        title: title,
                        description: description,
                        thumbnail: thumbnail._id
                            ? thumbnail
                            : props.VIPCircle.avatar,
                        monthlySubscription: monthlySubscription,
                        annuallySubscription: annuallySubscription,
                        guests: [...props.VIPCircle.guests, ...curGuests],
                    })
                );
            }
        } else {
            setForm(true);
        }
    };

    let filteredUsers = users.filter((x) => x._id !== userProfile._id);

    if (!IsNullOrEmpty(selectedMenu)) {
        let updated = vipGuests
            .filter((x) => x.status === selectedMenu)
            .map((x) => x.userId);
        filteredUsers = filteredUsers.filter((item) => {
            return updated.indexOf(item._id) > -1;
        });
    } else {
        let updated = vipGuests.map((x) => x.userId);
        filteredUsers = filteredUsers.filter((item) => {
            return updated.indexOf(item._id) === -1;
        });
    }

    if (!IsNullOrEmpty(searchText)) {
        filteredUsers = filteredUsers.filter((item) => {
            return (
                item.fullName.toLowerCase().indexOf(searchText.toLowerCase()) >
                -1
            );
        });
    }

    return (
        <div className="p-2">
            <Grid container spacing={2}>
                <Grid item md={4} lg={4} xs={12} sm={12}>
                    <div className="upload-btn-img bg-img">
                        <img
                            src={bannerImageSrc ? bannerImageSrc : ThumbLine}
                            className={"product-image"}
                            alt="userprofile"
                        />
                        <input
                            type="file"
                            name="banner_image"
                            onChange={changeBanner}
                        />
                    </div>
                </Grid>
                <Grid item md={8} lg={8} xs={12} sm={12}>
                    <TextField
                        variant="outlined"
                        className="my-2"
                        color="primary"
                        error={form && IsNullOrEmpty(title)}
                        helperText={
                            form && IsNullOrEmpty(title)
                                ? "Title should not be empty"
                                : ""
                        }
                        fullWidth
                        label="Title"
                        placeholder="Title"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                    />
                    {props.mode == "edit" ? (
                        <Box
                            onClick={() => setShared(true)}
                            className="mb-2"
                            textAlign="center"
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                        >
                            <div>
                                <span className="text-large text-primary">
                                    {
                                        props.VIPCircle.guests.filter(
                                            (x) => x.status === "Invited"
                                        ).length
                                    }
                                </span>{" "}
                                <br />
                                <span className="text-secondary">Invited</span>
                            </div>
                            <div>
                                <span className="text-large text-primary">
                                    {
                                        props.VIPCircle.guests.filter(
                                            (x) => x.status === "Requested"
                                        ).length
                                    }
                                </span>{" "}
                                <br />
                                <span className="text-secondary">Pending</span>
                            </div>
                            <div>
                                <span className="text-large text-primary">
                                    {" "}
                                    {
                                        props.VIPCircle.guests.filter(
                                            (x) => x.status === "Subscribed"
                                        ).length
                                    }
                                </span>{" "}
                                <br />
                                <span className="text-secondary">
                                    Subscribed
                                </span>
                            </div>
                        </Box>
                    ) : (
                        <Box
                            onClick={() => setShared(true)}
                            className="my  -2 text grey"
                            textAlign="center"
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                        >
                            <div>
                                <span className="text-grey">0</span> <br />
                                <span className="text-black-60">Invited</span>
                            </div>
                            <div>
                                <span className="text-grey">0</span> <br />
                                <span className="text-black-60">Pending</span>
                            </div>
                            <div>
                                <span className="text-grey">0</span> <br />
                                <span className="text-black-60">Approved</span>
                            </div>
                            <div>
                                <span className="text-grey">0</span> <br />
                                <span className="text-black-60">Rejected</span>
                            </div>
                            <div>
                                <span className="text-grey">0</span> <br />
                                <span className="text-black-60">
                                    Subscribed
                                </span>
                            </div>
                        </Box>
                    )}
                </Grid>
                <Grid item md={12} lg={12} xs={12} sm={12}>
                    <TextField
                        variant="outlined"
                        className="my-2"
                        color="primary"
                        fullWidth
                        label="Monthly subscription fee"
                        placeholder="Monthly Fee 0.00"
                        type="number"
                        error={form && IsNullOrEmpty(monthlySubscription)}
                        helperText={
                            form && IsNullOrEmpty(monthlySubscription)
                                ? "Monthly subscription should not be empty"
                                : ""
                        }
                        value={monthlySubscription}
                        onChange={(e) => {
                            setMonthlySubscription(e.target.value);
                            setAnnuallySubscription(12 * e.target.value);
                        }}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    {userProfile.country.currency}
                                </InputAdornment>
                            ),
                            endAdornment: (
                                <InputAdornment position="start">
                                    / month
                                </InputAdornment>
                            ),
                        }}
                    />
                    <TextField
                        variant="outlined"
                        className="my-2"
                        color="primary"
                        fullWidth
                        label="Yearly subscription fee"
                        placeholder="Yearly Fee 0.00"
                        type="number"
                        value={annuallySubscription}
                        error={form && IsNullOrEmpty(annuallySubscription)}
                        helperText={
                            form && IsNullOrEmpty(annuallySubscription)
                                ? "Yearly subscription should not be empty"
                                : ""
                        }
                        onChange={(e) =>
                            setAnnuallySubscription(e.target.value)
                        }
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    {userProfile.country.currency}
                                </InputAdornment>
                            ),
                            endAdornment: (
                                <InputAdornment position="start">
                                    / year
                                </InputAdornment>
                            ),
                        }}
                    />
                    <TextField
                        variant="outlined"
                        multiline
                        minRows={3}
                        className="my-2"
                        color="primary"
                        error={form && IsNullOrEmpty(description)}
                        helperText={
                            form && IsNullOrEmpty(description)
                                ? "Description should not be empty"
                                : ""
                        }
                        fullWidth
                        label="Description"
                        placeholder="Describe your content to the subscribers"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                    />
                    {props.mode !== "edit" ? (
                        <Box
                            className="mb-2"
                            textAlign="center"
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                        >
                            <Button
                                variant="outlined"
                                className="mx-1"
                                fullWidth
                                color="default"
                                onClick={() => {
                                    props.onClose();
                                }}
                            >
                                Cancel
                            </Button>
                            <Button
                                variant="contained"
                                className="mx-1"
                                fullWidth
                                color="primary"
                                onClick={() => handleSave()}
                            >
                                Add
                            </Button>
                        </Box>
                    ) : (
                        <Box
                            className="mb-2"
                            textAlign="center"
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                        >
                            <Button
                                variant="outlined"
                                className="mx-1"
                                fullWidth
                                color="default"
                                onClick={() => props.onClose()}
                            >
                                Cancel
                            </Button>
                            <Button
                                variant="contained"
                                className="mx-1"
                                fullWidth
                                color="primary"
                                onClick={() => handleSave()}
                            >
                                Update
                            </Button>
                        </Box>
                    )}
                    {props.VIPCircle.guests &&
                    props.VIPCircle.guests.filter(
                        (x) => x.status === "Subscribed"
                    ).length === 0 ? (
                        <div align="center">
                            <Button
                                className="text-danger text-center"
                                onClick={() => handleDelete()}
                            >
                                Delete Circle
                            </Button>
                        </div>
                    ) : (
                        <></>
                    )}
                    <Dialog
                        maxWidth="sm"
                        fullWidth
                        open={showShared}
                        onClose={() => setShared(false)}
                    >
                        <DialogContent>
                            <h3 className="text-lg font-medium text-ebony-color my-2">
                                Invite Guests
                                <CloseOutlined
                                    className="float-right"
                                    onClick={() => setShared(false)}
                                />
                            </h3>
                            <Divider />
                            <Grid container>
                                <Grid item xs={12} sm={12} className="mb-2">
                                    <TextField
                                        value={searchText}
                                        variant="outlined"
                                        margin="dense"
                                        fullWidth
                                        onChange={(e) =>
                                            setSearchText(e.target.value)
                                        }
                                        placeholder="Search users"
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <SearchOutlined />
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} className="mb-4">
                                    <Paper square>
                                        <Tabs
                                            variant="fullWidth"
                                            value={selectedMenu}
                                            maxWidth={false}
                                            indicatorColor="primary"
                                            textColor="primary"
                                            onChange={(e, val) => {
                                                setSelectedMenu(val);
                                            }}
                                        >
                                            <Tab
                                                value=""
                                                fullWidth
                                                label={"All"}
                                            />
                                            <Tab
                                                value="Invited"
                                                fullWidth
                                                label={`Invited (${
                                                    vipGuests.filter(
                                                        (x) =>
                                                            x.status ===
                                                            "Invited"
                                                    ).length
                                                })`}
                                            />
                                            <Tab
                                                value="Requested"
                                                fullWidth
                                                label={`Request (${
                                                    vipGuests.filter(
                                                        (x) =>
                                                            x.status ===
                                                            "Requested"
                                                    ).length
                                                })`}
                                            />
                                            {/* <Tab
                                        value="Approved"
                                        fullWidth
                                        label={`Approved (${vipGuests.filter((x) => x.status === "Approved").length})`}
                                    /> */}

                                            <Tab
                                                value="Subscribed"
                                                fullWidth
                                                label={`Subscribed (${
                                                    vipGuests.filter(
                                                        (x) =>
                                                            x.status ===
                                                            "Subscribed"
                                                    ).length
                                                })`}
                                            />
                                        </Tabs>
                                    </Paper>
                                </Grid>
                                {filteredUsers.map((item, pos) => {
                                    let isActive =
                                        guests.indexOf(item._id) > -1;
                                    let curUser = _.find(
                                        vipGuests,
                                        (x) => x.userId === item._id
                                    );
                                    return (
                                        <Grid
                                            item
                                            key={item._id}
                                            sm={6}
                                            xs={6}
                                            md={3}
                                            lg={3}
                                        >
                                            <Box
                                                textAlign="center"
                                                className="my-2"
                                                display={"flex"}
                                                justifyContent="center"
                                                alignItems={"center"}
                                                flexDirection={"column"}
                                            >
                                                <Badge
                                                    badgeContent={
                                                        curUser &&
                                                        curUser.status ===
                                                            "Approved" ? (
                                                            <CancelOutlinedIcon
                                                                fontSize="small"
                                                                color="error"
                                                                onClick={() => {
                                                                    setVIPGuests(
                                                                        vipGuests.map(
                                                                            (
                                                                                x
                                                                            ) => {
                                                                                if (
                                                                                    x.userId ===
                                                                                    item._id
                                                                                ) {
                                                                                    x.status =
                                                                                        "Rejected";
                                                                                }
                                                                                return x;
                                                                            }
                                                                        )
                                                                    );

                                                                    SocialAPI.sendPushNotification(
                                                                        {
                                                                            userIds:
                                                                                [
                                                                                    curUser.iserI,
                                                                                ],
                                                                            title: "Subscribe",
                                                                            content:
                                                                                "Reject Request",
                                                                            type: "vipCircle",
                                                                            data: {
                                                                                guest: curUser,
                                                                                status: "Rejected",
                                                                                title: title,
                                                                                _id: props
                                                                                    .VIPCircle
                                                                                    ._id,
                                                                                owner: userProfile,
                                                                            },
                                                                        }
                                                                    );

                                                                    setTimeout(
                                                                        () => {
                                                                            handleSave();
                                                                        },
                                                                        1000
                                                                    );
                                                                }}
                                                            />
                                                        ) : curUser &&
                                                          curUser.status ===
                                                              "Rejected" ? (
                                                            <CheckCircleOutlinedIcon
                                                                fontSize="small"
                                                                color="primary"
                                                                onClick={() => {
                                                                    setVIPGuests(
                                                                        vipGuests.map(
                                                                            (
                                                                                x
                                                                            ) => {
                                                                                if (
                                                                                    x.userId ===
                                                                                    item._id
                                                                                ) {
                                                                                    x.status =
                                                                                        "Invited";
                                                                                }
                                                                                return x;
                                                                            }
                                                                        )
                                                                    );
                                                                    let selectedUsr =
                                                                        _.find(
                                                                            users,
                                                                            (
                                                                                z
                                                                            ) =>
                                                                                z._id ===
                                                                                curUser.userId
                                                                        );
                                                                    if (
                                                                        selectedUsr
                                                                    ) {
                                                                        let mail = `<p style="text-align: center;
                                                                background: #8B22F9;
                                                                color: white;
                                                                font-weight: bold;
                                                                line-height: 28px;
                                                                font-size: 20px;
                                                                padding: 12px;">
                                                                    Access Granted
                                                                </p>
                                                                <p style="line-height: 30px;text-align: center;">
                                                                    <span style="color:#8B22F9"> ${
                                                                        userProfile.fullName
                                                                    }</span> is delighted to give you access to join their
                                                                    VIP Room live sessions.
                                                                    <br />
                                                                    <br />
                                                                    Join their room before it ends
                                                                </p>
                                                                <div style="border: 1px solid; border-radius: 30px;padding: 10px">
                                                                    <table border="0">
                                                                        <tr>
                                                                            <td>
                                                                                <img width="100" height="100"
                                                                                    src="${getImage(
                                                                                        selectedUsr.attachments
                                                                                    )}" />
                                                                            </td>
                                                                            <td>
                                                                                <p style="color: #8B22F9; font-weight:bold;line-height: 12px;">${
                                                                                    selectedUsr.fullName
                                                                                }</p>
                                                                                <p style="color: #000; font-weight:bold;line-height: 12px">${title}</p>
                                                        
                                                                                <p style="text-align: center;padding: 16px;">
                                                                                    <a href="https://app.ulalive.com/" style="background: #8B22F9;
                                                                    color: white;
                                                                    padding: 16px;
                                                                    text-decoration: none;
                                                                    border-radius: 16px;
                                                                    font-weight: bold;">
                                                                                        Join Live
                                                                                    </a>
                                                                                </p>
                                                                            </td>
                                                                        </tr>
                                                                    </table>
                                                                </div>`;

                                                                        SocialAPI.sendEmailNotification(
                                                                            {
                                                                                message:
                                                                                    mail,
                                                                                subject:
                                                                                    "VIP Circle Access Granted From Ulalive",
                                                                                to: selectedUsr.email,
                                                                            }
                                                                        );

                                                                        SocialAPI.sendPushNotification(
                                                                            {
                                                                                userIds:
                                                                                    [
                                                                                        selectedUsr._id,
                                                                                    ],
                                                                                title: "Subscribe",
                                                                                content:
                                                                                    "Approve Request",
                                                                                type: "vipCircle",
                                                                                data: {
                                                                                    guest: curUser,
                                                                                    status: "Approved",
                                                                                    title: title,
                                                                                    _id: props
                                                                                        .VIPCircle
                                                                                        ._id,
                                                                                    owner: userProfile,
                                                                                },
                                                                            }
                                                                        );
                                                                    }
                                                                    setTimeout(
                                                                        () => {
                                                                            handleSave();
                                                                        },
                                                                        1000
                                                                    );
                                                                }}
                                                            />
                                                        ) : (
                                                            <span />
                                                        )
                                                    }
                                                >
                                                    <Avatar
                                                        style={{
                                                            height: 64,
                                                            width: 64,
                                                            border:
                                                                curUser &&
                                                                curUser.status ===
                                                                    "Requested"
                                                                    ? "3px solid goldenrod"
                                                                    : curUser &&
                                                                      curUser.status ===
                                                                          "Approved"
                                                                    ? "3px solid green"
                                                                    : curUser &&
                                                                      curUser.status ===
                                                                          "Rejected"
                                                                    ? "3px solid red"
                                                                    : isActive
                                                                    ? "3px solid #0038FF"
                                                                    : "1px solid #CECECE",
                                                        }}
                                                        src={getImage(
                                                            item.attachments
                                                        )}
                                                        title={item.fullName}
                                                        alt={item.fullName}
                                                        onClick={() => {
                                                            if (!curUser) {
                                                                let index =
                                                                    guests.findIndex(
                                                                        (x) =>
                                                                            x ===
                                                                            item._id
                                                                    );
                                                                if (
                                                                    index > -1
                                                                ) {
                                                                    let newGuests =
                                                                        guests.filter(
                                                                            (
                                                                                y
                                                                            ) =>
                                                                                y !==
                                                                                item._id
                                                                        );
                                                                    setGuests(
                                                                        newGuests
                                                                    );
                                                                } else {
                                                                    setGuests([
                                                                        ...guests,
                                                                        item._id,
                                                                    ]);
                                                                }
                                                            }
                                                        }}
                                                    />
                                                </Badge>
                                                <span
                                                    className="overflow-text text-small"
                                                    title={item.fullName}
                                                    style={{
                                                        color:
                                                            curUser &&
                                                            curUser.status ===
                                                                "Requested"
                                                                ? "goldenrod"
                                                                : curUser &&
                                                                  curUser.status ===
                                                                      "Approved"
                                                                ? "green"
                                                                : curUser &&
                                                                  curUser.status ===
                                                                      "Rejected"
                                                                ? "red"
                                                                : isActive
                                                                ? "#0038FF"
                                                                : "#000",
                                                    }}
                                                >
                                                    {item.fullName}
                                                    {curUser &&
                                                    curUser.status ===
                                                        "Requested" ? (
                                                        <Box
                                                            display={"flex"}
                                                            width="85%"
                                                            justifyContent="space-between"
                                                        >
                                                            <CancelOutlinedIcon
                                                                fontSize="small"
                                                                color="error"
                                                                onClick={() => {
                                                                    setVIPGuests(
                                                                        vipGuests.map(
                                                                            (
                                                                                x
                                                                            ) => {
                                                                                if (
                                                                                    x.userId ===
                                                                                    item._id
                                                                                ) {
                                                                                    x.status =
                                                                                        "Rejected";
                                                                                }
                                                                                return x;
                                                                            }
                                                                        )
                                                                    );

                                                                    SocialAPI.sendPushNotification(
                                                                        {
                                                                            userIds:
                                                                                [
                                                                                    curUser.iserI,
                                                                                ],
                                                                            title: "Subscribe",
                                                                            content:
                                                                                "Reject Request",
                                                                            type: "vipCircle",
                                                                            data: {
                                                                                guest: curUser,
                                                                                status: "Rejected",
                                                                                title: title,
                                                                                _id: props
                                                                                    .VIPCircle
                                                                                    ._id,
                                                                                owner: userProfile,
                                                                            },
                                                                        }
                                                                    );

                                                                    setTimeout(
                                                                        () => {
                                                                            handleSave();
                                                                        },
                                                                        1000
                                                                    );
                                                                }}
                                                            />
                                                            <CheckCircleOutlinedIcon
                                                                fontSize="small"
                                                                color="primary"
                                                                onClick={() => {
                                                                    setVIPGuests(
                                                                        vipGuests.map(
                                                                            (
                                                                                x
                                                                            ) => {
                                                                                if (
                                                                                    x.userId ===
                                                                                    item._id
                                                                                ) {
                                                                                    x.status =
                                                                                        "Approved";
                                                                                }
                                                                                return x;
                                                                            }
                                                                        )
                                                                    );
                                                                    let selectedUsr =
                                                                        _.find(
                                                                            users,
                                                                            (
                                                                                z
                                                                            ) =>
                                                                                z._id ===
                                                                                curUser.userId
                                                                        );
                                                                    if (
                                                                        selectedUsr
                                                                    ) {
                                                                        let mail = `<p style="text-align: center;
                                                                    background: #8B22F9;
                                                                    color: white;
                                                                    font-weight: bold;
                                                                    line-height: 28px;
                                                                    font-size: 20px;
                                                                    padding: 12px;">
                                                                        Access Granted
                                                                    </p>
                                                                    <p style="line-height: 30px;text-align: center;">
                                                                        <span style="color:#8B22F9"> ${
                                                                            userProfile.fullName
                                                                        }</span> is delighted to give you access to join their
                                                                        VIP Room live sessions.
                                                                        <br />
                                                                        <br />
                                                                        Join their room before it ends
                                                                    </p>
                                                                    <div style="border: 1px solid; border-radius: 30px;padding: 10px">
                                                                        <table border="0">
                                                                            <tr>
                                                                                <td>
                                                                                    <img width="100" height="100"
                                                                                        src="${getImage(
                                                                                            selectedUsr.attachments
                                                                                        )}" />
                                                                                </td>
                                                                                <td>
                                                                                    <p style="color: #8B22F9; font-weight:bold;line-height: 12px;">${
                                                                                        selectedUsr.fullName
                                                                                    }</p>
                                                                                    <p style="color: #000; font-weight:bold;line-height: 12px">${
                                                                                        selectedUsr.userName
                                                                                    }</p>
                                                            
                                                                                    <p style="text-align: center;padding: 16px;">
                                                                                        <a href="https://app.ulalive.com/" style="background: #8B22F9;
                                                                        color: white;
                                                                        padding: 16px;
                                                                        text-decoration: none;
                                                                        border-radius: 16px;
                                                                        font-weight: bold;">
                                                                                            Join Live
                                                                                        </a>
                                                                                    </p>
                                                                                </td>
                                                                            </tr>
                                                                        </table>
                                                                    </div>`;

                                                                        SocialAPI.sendEmailNotification(
                                                                            {
                                                                                message:
                                                                                    mail,
                                                                                subject:
                                                                                    "VIP Circle Access Granted From Ulalive",
                                                                                to: selectedUsr.email,
                                                                            }
                                                                        );

                                                                        SocialAPI.sendPushNotification(
                                                                            {
                                                                                userIds:
                                                                                    [
                                                                                        selectedUsr._id,
                                                                                    ],
                                                                                title: "Subscribe",
                                                                                content:
                                                                                    "Approve Request",
                                                                                type: "vipCircle",
                                                                                data: {
                                                                                    guest: curUser,
                                                                                    status: "Approved",
                                                                                    title: title,
                                                                                    _id: props
                                                                                        .VIPCircle
                                                                                        ._id,
                                                                                    owner: userProfile,
                                                                                },
                                                                            }
                                                                        );
                                                                    }
                                                                    setTimeout(
                                                                        () => {
                                                                            handleSave();
                                                                        },
                                                                        1000
                                                                    );
                                                                }}
                                                            />
                                                        </Box>
                                                    ) : (
                                                        <></>
                                                    )}
                                                </span>
                                            </Box>
                                        </Grid>
                                    );
                                })}
                                {filteredUsers.length === 0 && (
                                    <Grid item xs={12} sm={12} className="mb-2">
                                        <Box
                                            display="flex"
                                            justifyContent="center"
                                            className="mt-4"
                                            width="100%"
                                        >
                                            <img
                                                src={NotFound}
                                                alt="icon"
                                                className="img-responsive"
                                            />
                                        </Box>
                                    </Grid>
                                )}
                            </Grid>
                        </DialogContent>
                        <DialogActions>
                            {(selectedMenu === "" ||
                                selectedMenu === "Requested") && (
                                <Button
                                    fullWidth
                                    variant="contained"
                                    color="secondary"
                                    onClick={() => handleSave()}
                                >
                                    {selectedMenu === ""
                                        ? "Send invite"
                                        : selectedMenu === "Requested"
                                        ? "Approve"
                                        : ""}
                                </Button>
                            )}
                        </DialogActions>
                    </Dialog>
                </Grid>
            </Grid>
        </div>
    );
}
